import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
	name: 'arrondiPlusProche'
})
export class ArrondiPlusProchePipeMock implements PipeTransform {

	constructor() {
	}

	transform(value: any, decimales: number): any {
		return value;
	}

}
